/**
 * The harness's own controls (`ui-primitives`), for Orik's components inside the harness.
 *
 * A client plugin cannot import another plugin's components: they are shared through the module loader, which
 * hands every plugin the same instance with the same styles. Orik's entry resolves the package there when the
 * kernel applies it (`harness/orik-harness.ts`) and records it here, so Orik's occupants draw the same buttons,
 * tags and dialogs as the harness beside them. Every occupant renders after the kernel has applied that entry.
 */
import type * as UiPrimitives from "@deepseek-ai/dsh-client-ui-primitives";

export type HarnessPrimitives = typeof UiPrimitives;

let loaded: HarnessPrimitives | undefined;

/** Record the package the module loader resolved. */
export function setHarnessPrimitives(primitives: HarnessPrimitives): void {
  loaded = primitives;
}

/** The harness's controls; only callable inside the harness's tree. */
export function harnessPrimitives(): HarnessPrimitives {
  if (loaded === undefined) throw new Error("orik harness: ui-primitives is not resolved yet; render this inside the harness");
  return loaded;
}
